import { render, staticRenderFns } from "./CertificateReminderDialog.vue?vue&type=template&id=10cb9eca"
import script from "./CertificateReminderDialog.vue?vue&type=script&lang=js"
export * from "./CertificateReminderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports